import React, { useEffect, useState } from 'react';
import '../Carousel/carousel.css';
import '../Inicio/inicio.css';
import { eventosDestacados } from '../../json/eventosDestacados';

const EventosDestacados = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

// Extraer las funciones necesarias de React
      const { useState } = React;
  //    const { render } = ReactDOM;

      // Estado para controlar la visibilidad del popup
      //const [isPopupOpen, setPopupOpen] = useState(false);

      // Función para abrir el popup
      //const openPopup = () => {
      //   setPopupOpen(true);
      //};

      // Función para cerrar el popup
      //const closePopup = () => {
      //  setPopupOpen(false);
      //};

  return (
    <>
    {
        eventosDestacados.map((item, index) => (

          <div className="row" key={index}>
                
                  <div style={{ width: `600px`, height: `400px` }}>
                    <div className='sec_function' style={{ width: `570px`, height: `190px` }}>
                      <p> <h3> {item.titulo} </h3> </p>
                    </div>
                    <br />
                    <div style={{ width: `570px`, height: `50px` }}>
                      <p style={{ fontWeight: `bold` }}> {item.fecha} </p>
                    </div>
                    <br />
                    <div id="descripcion" className='sec_function' style={{ width: `570px`, height: `130px` }}>
                       <p> {item.descripcion} </p>
                    </div>
                    <div className='btn_agenda'>
                          <a href={ item.boletin } target="_blank" rel="noopener noreferrer">.</a> {/*Leer mas...*/}
                    </div>
                  </div>

                  <div id="carrusel" className="carousel slide carouselBos" data-bs-ride="carousel" style={{ width: `690px`, height: `400px` }}>
                      <div className="carousel-inner">
                        {
                          item.imagenes.map(( img, i )=>(   
                            <div key={ i } className={ i >= 1 ? "carousel-item" : "carousel-item active" }>
                              
                                <div className="img-carousel d-block w-100"><img id="imgGaleria" src={ img.imagen } alt="First slide" /></div> 
                              
                            </div>
                          ))
                        }
                      </div>
                      <button className="carousel-control-prev" type="button" data-bs-target="#carrusel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carrusel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                </div>
                
        </div>

        ))
      }

    </>
  )
}

export default EventosDestacados